import React from 'react'
import { splitRegistration } from '@cbgms/base/utils/vehicle'
import { Button } from 'semantic-ui-react'
import { CountryCode } from '@carsys/enums/country-code'
import { VehicleAssignedAs } from '@cbgms/api/modules/enums'
import classNames from 'classnames'
import { VehicleType } from './VehicleType'
import CopyToClipboard from '@cbgms/components/general/CopyToClipboard'
import { useTranslation } from 'react-i18next'
import { useLicensePlateInputStyles } from '@carsys/ui/src/LicensePlate/LicensePlateInputBase'
import { useGetRegistrationDisplayConfig } from '@carsys/ui/src/LicensePlate/use-get-registration-display-config'

export interface ILicensePlateProps {
  className?: string
  'data-testid'?: string
  registration: string | undefined
  size?: 'small' | 'medium' | 'large' | 'big' | 'huge' | 'massive' | 'tiny'
  style?: object
  type?: VehicleAssignedAs
  vehicleTypeIconColor?: string
  showCopyButton?: boolean

  onDelete?(): void
}

const LicensePlate: React.FC<ILicensePlateProps> = ({
  registration,
  type,
  onDelete,
  size,
  className,
  style,
  'data-testid': testId,
  vehicleTypeIconColor,
  showCopyButton = false
}) => {
  const classes = useLicensePlateInputStyles()
  const { countryCode, licensePlate } = splitRegistration(registration)
  const registrationDisplay = useGetRegistrationDisplayConfig(countryCode as CountryCode)
  const { t } = useTranslation()

  if (!registration) {
    return null
  }
  const licenseClassName = `${classes.licenseplate} ${countryCode} ${size || ''} ${className || ''}`
  const countryClassName = classNames('country', { eu: size !== 'tiny' && registrationDisplay.isEU })

  return (
    <div className={licenseClassName} style={style} data-testid='license-plate-wrapper'>
      <div data-testid='license-country-code' className={countryClassName}>
        <span>{registrationDisplay.countryCode}</span>
      </div>
      <div className='number' data-testid={testId}>
        {licensePlate.split('').map((character, index) => {
          return (
            <React.Fragment key={index}>
              {character === '-' && <div className='stripe'>{character}</div>}
              {character === ' ' && <div className='spacer'>{character}</div>}
              {character !== '-' && character !== ' ' && <div className='letter'>{character}</div>}
            </React.Fragment>
          )
        })}
        {onDelete && (
          <Button data-testid='licenseplate-delete-btn' floated='right' compact color='red' circular icon='remove' onClick={onDelete} />
        )}
      </div>
      {showCopyButton && (
        <CopyToClipboard
          tooltip={t('vehicle.copy_registration')}
          value={licensePlate}
          sx={{ paddingRight: 0, paddingLeft: 0, marginLeft: '5px !important' }}
          iconStyle={{ maxHeight: '1rem', maxWidth: '1rem' }}
        />
      )}
      {type && <VehicleType type={type} iconColor={vehicleTypeIconColor} />}
    </div>
  )
}

export default LicensePlate
